<script setup lang="ts">

    import { defineProps, defineEmits, reactive, ref, onMounted, computed } from "vue";

    const emit = defineEmits(["uploaded"])
    const props = defineProps({
        id: { type: String, required: true },
        caption: { type: String, default: '' },
        label: { type: String, default: 'Fichier' },
        required: { type: Boolean, default: false }
    });
    const extensionsAllowed = ['.pdf', '.doc', '.docx', '.xls', '.xlsx'];
    const formValue = reactive({
        file: '',
        file_name: '',
        file_preview: null as any,
    });

    function onFileUploaded(event: any) {
        if (event.target.files.length > 0) {
            var reader = new FileReader();
            reader.onload = function(e) {
                formValue.file = event.target.files[0];
                formValue.file_name = event.target.files[0].name;
                formValue.file_preview = e.target!.result as string;
                emit('uploaded', formValue);
            }
            reader.readAsDataURL(event.target.files[0]);
        }
    }

</script>
<template>
    <label :for="props.id" class="custom-upload my-5" :class="{'active': formValue.file}"><!--active-->
        <div class="custom-upload-st2">
            <input :id="props.id" class="display-none" type="file" ref="fichier_photo" @change="onFileUploaded($event)" :accept="extensionsAllowed.join(',')" />
            <div class="s4 custom-upload-img">{{ props.caption }}</div>
            <div class="s12">
                <span id="file-upload-title" class="custom-upload-text">{{ props.label }}</span>
                <b class="color-danger">*</b><br>
                <span id="file-upload-title" class="custom-upload-text-sm">{{ formValue.file_name ? formValue.file_name : "Charger le doc"}}</span>
            </div>
            <div class="s4 right"><img src="/icons/icon-upload.svg" class="custom-upload-icon" /></div>
        </div>
    </label>
</template>